export default (theme) => ({
    container: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
    },

    containerAdjuntos: {
        display: 'flex',
        flexFlow: 'row wrap',
    },

    btnAdjuntar: {
        height: '38px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px 18px',
        borderRadius: '6px',
        fontWeight: '500',
        fontSize: '13px',
        lineHeight: '18px',
        color: '#02599E',
        minWidth: '190px',
        cursor: 'pointer',
        marginRight: '15px',
        textTransform: 'none',
        border: '1px dashed rgba(182, 182, 182, 0.41)',
        '&:focus': {
            outline: 'none',
        },
        '&:hover': {
            border: '1px dashed rgba(164, 163, 163, 0.84)',
            background: '#FFFFFF',
        },
    },

    iconoUpload: {
        width: '20px',
        marginRight: '8px',
    },
});
